import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id", "value", "disabled"]
const _hoisted_4 = ["for"]

import {useId} from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'option',
  props: /*@__PURE__*/_mergeModels({
    options: {
      default: null,
      required: true,
      type: Array<string>
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  }, {
    "selection": {
    default: null,
    required: true,
    type: String
  },
    "selectionModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update"], ["update:selection"]),
  setup(__props, { emit: __emit }) {

  

  const emits = __emit
  const id = useId()
  const selection = _useModel(__props, "selection")

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (__props.title)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _unref(id)
          }, _toDisplayString(__props.title), 9, _hoisted_1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("span", {
          id: _unref(id),
          key: option
        }, [
          _withDirectives(_createElementVNode("input", {
            id: `${_unref(id)}-${option}`,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selection).value = $event)),
            value: option,
            type: "radio",
            disabled: __props.readOnly,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (emits('update')))
          }, null, 40, _hoisted_3), [
            [_vModelRadio, selection.value]
          ]),
          _createElementVNode("label", {
            for: `${_unref(id)}-${option}`
          }, _toDisplayString(option), 9, _hoisted_4)
        ], 8, _hoisted_2))
      }), 128))
    ]),
    _: 1
  }))
}
}

})